import { CreditCheckFailureModal } from './CreditCheckFailureModal';
import { OrderSubmissionErrorModal } from './OrderSubmissionErrorModal';
import { OrderSubmissionProgressModal } from './OrderSubmissionProgressModal';
import { UnavailableNumbersModal } from './UnavailableNumbersModal';

export interface PlaceOrderModalsProps {
  isSubmittingOrder: boolean;
  showOrderErrorModal: boolean;
  showCreditCheckModal: boolean;
  showUnavailableNumbersModal: boolean;
  unavailableNumbers: string[];
  isReplacingNumbers: boolean;
  onCloseOrderErrorModal: () => void;
  onCloseCreditCheckModal: () => void;
  onConfirmNumberReplacement: () => void;
  onCancelNumberReplacement: () => void;
}

/**
 * Container component for all order submission related modals.
 * Renders progress, error, credit check failure, and unavailable numbers modals based on state.
 */
export const PlaceOrderModals = ({
  isSubmittingOrder,
  showOrderErrorModal,
  showCreditCheckModal,
  showUnavailableNumbersModal,
  unavailableNumbers,
  isReplacingNumbers,
  onCloseOrderErrorModal,
  onCloseCreditCheckModal,
  onConfirmNumberReplacement,
  onCancelNumberReplacement,
}: PlaceOrderModalsProps) => (
  <>
    <OrderSubmissionProgressModal isOpen={isSubmittingOrder} />
    <OrderSubmissionErrorModal isOpen={showOrderErrorModal} onClose={onCloseOrderErrorModal} />
    <CreditCheckFailureModal isOpen={showCreditCheckModal} onClose={onCloseCreditCheckModal} />
    <UnavailableNumbersModal
      isOpen={showUnavailableNumbersModal}
      unavailableNumbers={unavailableNumbers}
      onConfirmWithReplacement={onConfirmNumberReplacement}
      onCancel={onCancelNumberReplacement}
      isProcessing={isReplacingNumbers}
    />
  </>
);
